import { type ThemeDefinition } from 'vuetify';
import colors from 'vuetify/util/colors';

export const defaultDark: ThemeDefinition = {
    dark: true,
    colors: {
        primary: colors.indigo.darken2,
    },
};
